import axios from "axios";
import { PollCancelFulfillRequest, PollCancelFulfillResponse } from "redmond";
import { config } from "../../config";
import { getActivitiesCancelFulfillPollPath } from "../paths";

export const getActivitiesCancelFulfillPoll = async (
  req: PollCancelFulfillRequest
): Promise<PollCancelFulfillResponse> => {
  const res = await axios.put(getActivitiesCancelFulfillPollPath, req, {
    baseURL: config.baseURL,
  });

  return res.data;
};
